export function buildImageLink(image: { path: string }) {
  return `https://cdn.robloxscripts.gg/public/${image.path}`;
}

export function buildAvatarLink(username: string) {
  return `https://cdn.robloxscripts.gg/public/${username}/avatar.webp`;
}
